module.exports = __webpack_public_path__ + "img/IMG_20191125_201318.fac8d1a8.jpg";